export default {
  giftCardTitle: {
    id: 'gift_cards_results_gift_card_title',
    defaultMessage: 'Back Market Gift Card - {price}',
  },
  emailDelivery: {
    id: 'gift_cards_results_email_delivery',
    defaultMessage: 'Email delivery',
  },
}
